/** Closed canonical bundle of the Insights answers. */
import * as z from 'zod';
import { productHistoryAnswerSchema } from './product-history-answer.js';
import { productPairsAnswerSchema } from './product-pairs-answer.js';
import { repeatBuyingAnswerSchema } from './repeat-buying-answer.js';
import { productMixAnswerSchema } from './product-mix-answer.js';
const answerSchemas = {
    repeatBuying: repeatBuyingAnswerSchema,
    productMix: productMixAnswerSchema,
    productHistory: productHistoryAnswerSchema,
    productPairs: productPairsAnswerSchema,
};
/** Every answer the page response carries; consumers derive their per-answer checks from this list. */
export const insightAnswerKeys = Object.keys(answerSchemas);
export const insightsAnswersSchema = z.strictObject(answerSchemas);
//# sourceMappingURL=insights-answers.js.map